
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/home/testimonials-section.kpa`,
      template: `<section class="testimonials-section">
        <div class="wrapper">
            <div class="testimonials-slider" ref="slider">
                <div class="testimonial active">
                    <p>"Dieser Hausmeisterservice ist fantastisch! Sie halten alles in einwandfreiem Zustand."</p>
                    <h4>- Max Mustermann</h4>
                </div>

                <div class="testimonial">
                    <p>"Sehr zuverlässig und professionell. Ich kann ihren Service nur empfehlen."</p>
                    <h4>- Anna Müller</h4>
                </div>

                <div class="testimonial">
                    <p>"Hervorragender Kundenservice und jedes Mal ausgezeichnete Ergebnisse."</p>
                    <h4>- Michael Schmidt</h4>
                </div>
            </div>
        </div>
    </section>`,
      style: `testimonials-section .testimonials-section {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: #64c16c;
}
testimonials-section .testimonials-section .wrapper {
  padding: 0;
}
testimonials-section .testimonials-section .wrapper .testimonials-slider {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
}
testimonials-section .testimonials-section .wrapper .testimonials-slider .testimonial {
  max-width: 600px;
  width: 100%;
  opacity: 0;
  transition: opacity 1s ease-in-out;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
testimonials-section .testimonials-section .wrapper .testimonials-slider .testimonial p {
  position: relative;
  font-family: "Merriweather", serif;
  font-size: 1.4rem;
  margin: 0 0 8px 0;
  line-height: 1.6;
}
testimonials-section .testimonials-section .wrapper .testimonials-slider .testimonial h4 {
  font-family: "Merriweather", serif;
  font-size: 1rem;
  color: #f9f9f9;
  text-align: right;
  margin: 0;
}
testimonials-section .testimonials-section .wrapper .testimonials-slider .testimonial.active {
  opacity: 1;
  transition: opacity 1s 1s ease-in-out;
}
@media (min-width: 900px) {
  testimonials-section .testimonials-section .wrapper .testimonials-slider .testimonial {
    width: 80%;
  }
}
@media (min-width: 600px) {
  testimonials-section .testimonials-section .wrapper .testimonials-slider .testimonial {
    width: 80%;
  }
}
@media (max-width: 600px) {
  testimonials-section .testimonials-section .wrapper .testimonials-slider .testimonial {
    transform: translate(-50%, -50%) scale(0.9);
  }
}
@media (max-width: 480px) {
  testimonials-section .testimonials-section .wrapper .testimonials-slider .testimonial {
    transform: translate(-50%, -50%) scale(0.8);
  }
}
@media (max-width: 400px) {
  testimonials-section .testimonials-section .wrapper .testimonials-slider .testimonial {
    transform: translate(-50%, -50%) scale(0.7);
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    mounted() {
        const testimonials = $refs.slider.querySelectorAll('div');
        let currentIndex = 0;
        setInterval(() => {
            testimonials[currentIndex].classList.remove('active');
            currentIndex = (currentIndex + 1) % testimonials.length;
            testimonials[currentIndex].classList.add('active');
        }, 10000);
    }
};
 })()`
    };
  